import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/components/feature/Footer';
import AboutBanner from './components/AboutBanner';
import CompanyStats from './components/CompanyStats';
import BrandStory from './components/BrandStory';
import Timeline from './components/Timeline';
import CertificatesSection from './components/CertificatesSection';
import AboutCta from './components/AboutCta';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const ABOUT_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于 Koorpet - 匠心猫抓板品牌故事',
    description: '了解 Koorpet 的品牌故事、发展历程、核心团队与资质认证，专注猫抓板研发生产，天然环保材料。',
    url: `${siteUrl}/about`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: `${siteUrl}/about` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Koorpet',
    url: siteUrl,
    logo: `${siteUrl}/favicon.png`,
    foundingDate: '2024',
    description: '专注猫抓板研发生产，天然环保材料，10万+猫咪信赖之选',
    numberOfEmployees: { '@type': 'QuantitativeValue', value: 200 },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'cs@koorpet.com',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="关于 Koorpet - 匠心猫抓板品牌故事 | 天然环保宠物用品"
        description="了解 Koorpet 的品牌故事、发展历程、核心团队与资质认证，专注猫抓板研发生产，天然环保材料，10万+猫咪信赖之选。"
        keywords="Koorpet,品牌故事,猫抓板品牌,宠物用品厂家,天然环保"
        canonical="/about"
        ogImage="https://readdy.ai/api/search-image?query=pet%20brand%20story%20team%20office%20warm%20natural%20wood%20tones%20professional%20company%20culture%20minimalist&width=1200&height=630&seq=og-about-001&orientation=landscape"
        jsonLd={ABOUT_JSONLD}
      />
      <Navbar />
      <AboutBanner />
      <CompanyStats />
      <BrandStory />
      <Timeline />
      <CertificatesSection />
      <AboutCta />
      <Footer />
    </div>
  );
}